import { Box, Typography, useTheme } from '@mui/material';
import { mergeTheme } from '../types';
import type { ThemeCustomization } from '../types';

interface EventRulesProps {
  rulesForChildren?: string;
  observations?: string;
  themeCustomization?: ThemeCustomization;
}

export function EventRules({ rulesForChildren, observations, themeCustomization }: EventRulesProps) {
  const theme = useTheme();
  const mergedTheme = mergeTheme(themeCustomization);
  const textColor = mergedTheme.colors?.textColor || '#222222';

  return (
    <Box>
      {rulesForChildren && (
        <Box sx={{ mb: 3 }}>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              fontFamily: mergedTheme.typography?.fontFamily || 'Manrope, sans-serif', 
              color: textColor // Texto principal (título)
            }} 
            fontWeight={600} 
            gutterBottom
          >
            Regras para Crianças
          </Typography>
          <Box
            sx={{
              '& p': {
                marginBottom: 2,
                textAlign: 'justify',
                lineHeight: 1.8,
                color: textColor, // Texto principal
                fontSize: '0.9375rem',
                fontFamily: mergedTheme.typography?.fontFamily,
              },
            }}
            dangerouslySetInnerHTML={{ __html: rulesForChildren }}
          />
        </Box>
      )}

      {observations && (
        <Box>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              fontFamily: mergedTheme.typography?.fontFamily || 'Manrope, sans-serif', 
              color: textColor // Texto principal (título)
            }} 
            fontWeight={600} 
            gutterBottom
          >
            Observações Gerais
          </Typography>
          <Box
           sx={{
            '& p': {
              marginBottom: 2,
              textAlign: 'justify',
              lineHeight: 1.8,
              color: textColor, // Texto principal
              fontSize: '0.9375rem',
              fontFamily: mergedTheme.typography?.fontFamily,
            },
          }}
            dangerouslySetInnerHTML={{ __html: observations }}
          />
        </Box>
      )}
    </Box>
  );
}

